import { useState } from "react";
import { Formik, Form } from "formik";
import SidebarField from "../../../components/Sidebar/SidebarField";
import Button from "../../../components/Button";
import DOMPurify from "dompurify";

function AddStockLedgerReport({ currentItems, open, handleClose }) {
  const rolesData = [];
  const ComponentTypesData = [];
  const ComponentData = [];
  const allPermissions = [];
  const [componentOptions, setComponentOptions] = useState();

  const initialValues = {
    roleId: currentItems?.roleId?._id || "",
    componentType: currentItems?.componentType?._id || "",
    component: currentItems?.component?._id || "",
    permissions:
      currentItems?.permissions?.map((item) => item.permissionId) || [],
    active: currentItems?.active || false,
  };

  const handleSubmit = async (values, { resetForm }) => {
    console.log("Data", values);

    const permissionPayload = allPermissions.value?.data
      ?.map((item) => {
        if (values?.permissions.includes(item._id)) {
          return {
            permissionName: item.name,
            permissionId: item._id,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  if (!open) return null;

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ handleChange, values, setFieldValue }) => (
        <Form className="w-full gap-4 flex flex-col bg-transparent py-5 px-3">
          <SidebarField
            handleClose={handleClose}
            title={currentItems?._id ? currentItems?.itemCodeDetails?.name : "Description"}
            button1={<Button text="Cancel" type="button" onClick={handleClose} />}
            // button2={<Button text={currentItems?._id ? "Update" : "Submit"} type="submit" />}
          >
            <div className="p-4 bg-white shadow-lg rounded-lg">
              {/* Product Image */}
              <img
                src={currentItems?.itemCodeDetails?.primary_image}
                alt={currentItems?.itemCodeDetails?.name}
                className="w-full h-40 object-cover rounded-md"
              />

              {/* Transaction Info */}
              <h2 className="text-lg font-bold mt-4">{currentItems?.itemCodeDetails?.name}</h2>

              {/* Pricing & Quantity */}
              <div className="mt-3 p-3 border border-gray-300 rounded-lg bg-gray-100 shadow-sm">
                <p className="text-gray-800 font-semibold flex justify-between">
                  <span className="text-gray-600">Unit:</span>
                  {currentItems?.unitDetails?.map((item)=>item?.unit)}
                </p>

                <p className="text-gray-800 font-semibold flex justify-between mt-1">
                  <span className="text-gray-600">Balance Quantity:</span>
                  {currentItems?.balanceQuantity}
                </p>
              </div>

              {/* Description */}
              <div className="mt-4">
                <h3 className="text-md font-semibold">Description</h3>
                <p
                  className="text-gray-600 text-sm mt-2"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(currentItems?.itemDescription),
                  }}
                ></p>
              </div>
            </div>
          </SidebarField>
        </Form>
      )}
    </Formik>
  );
}

export default AddStockLedgerReport;
